import { createBrowserHistory } from '@tanstack/react-router';

type SilenceableHistory = ReturnType<typeof createBrowserHistory> & {
  _ignoreSubscribers?: boolean;
};

// react-router 3 never saw window.history.pushState/replaceState, so callers
// use them to change the URL (hash, program/category switch) without a route
// transition. TanStack patches both methods and would re-match the route.
export const createAppHistory = () => {
  const history: SilenceableHistory = createBrowserHistory();
  (['pushState', 'replaceState'] as const).forEach((method) => {
    const routed = window.history[method];
    window.history[method] = function (...args) {
      if (history._ignoreSubscribers) return routed.apply(this, args);
      history._ignoreSubscribers = true;
      try {
        return routed.apply(this, args);
      } finally {
        history._ignoreSubscribers = false;
      }
    };
  });
  return history;
};
